import React, { useState } from 'react';
import api from '../api';
import { X, Zap, Users, Info } from 'lucide-react';

function ActivateInterventionModal({ onClose, onSaved }) {
  const [form, setForm] = useState({ title: '', notes: '', required_people: 1 });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCreate = async () => {
    if (!form.title.trim()) return setError('Naziv je obavezan.');
    setLoading(true);
    try {
      await api.post('/interventions', form);
      onSaved();
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Greška.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ maxWidth: 480 }}>

        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 36, height: 36, borderRadius: 10, background: '#fde8e8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Zap size={18} color="#d63031" />
            </div>
            <div>
              <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#1a2a4a' }}>Aktiviraj intervenciju</h2>
              <div style={{ fontSize: 13, color: '#b2bec3', marginTop: 1 }}>Nova aktivna intervencija</div>
            </div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#b2bec3', padding: 4, borderRadius: 6, display: 'flex', alignItems: 'center' }}
            onMouseEnter={e => e.currentTarget.style.background = '#f5f6fa'}
            onMouseLeave={e => e.currentTarget.style.background = 'none'}>
            <X size={20} />
          </button>
        </div>

        {/* Info */}
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: '10px 12px', background: '#f0f9ff', border: '1px solid #bae6fd', borderLeft: '3px solid #0984e3', borderRadius: 8, marginBottom: 20, fontSize: 14, color: '#0369a1' }}>
          <Info size={14} style={{ flexShrink: 0, marginTop: 1 }} />
          Početak je postavljen na trenutno vrijeme, kraj na +3 sata. Možeš editirati naknadno.
        </div>

        {/* Naziv */}
        <div className="form-group">
          <label>Naziv intervencije *</label>
          <input
            value={form.title}
            onChange={e => setForm(p => ({ ...p, title: e.target.value }))}
            placeholder="npr. Požar — Ulica Slavonska 12"
            maxLength={100}
            autoFocus
          />
        </div>

        {/* Broj ljudi */}
        <div className="form-group">
          <label style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <Users size={13} color="#636e72" /> Potreban broj ljudi
          </label>
          <input
            type="number"
            min="1"
            value={form.required_people}
            onChange={e => setForm(p => ({ ...p, required_people: e.target.value }))}
          />
        </div>

        {/* Napomene */}
        <div className="form-group">
          <label>Napomene <span style={{ fontWeight: 400, color: '#b2bec3', fontSize: 13 }}>(opcionalno)</span></label>
          <textarea
            value={form.notes}
            onChange={e => setForm(p => ({ ...p, notes: e.target.value }))}
            placeholder="Dodatne napomene o intervenciji..."
            maxLength={2000}
            style={{ width: '100%', padding: '8px 12px', border: '1px solid #dfe6e9', borderRadius: 8, fontSize: 16, resize: 'vertical', minHeight: 80, outline: 'none' }}
          />
        </div>

        {error && <p className="error">{error}</p>}

        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onClose}>Odustani</button>
          <button className="btn btn-primary" onClick={handleCreate} disabled={loading}
            style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#d63031' }}>
            <Zap size={14} /> {loading ? 'Aktiviranje...' : 'Aktiviraj'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ActivateInterventionModal;
